import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { CreateBoardList } from './boardList';

export function ReferenceRoom(routeProps: RouteComponentProps) {
  useEffect(() => {}, []);

  return (
    <div className="content">
      {CreateBoardList(
        routeProps,
        {
          title: '자료실',
          subTitle: '도서출판 구민사의 자료실입니다.',
          visableButton: false,
          ctgy: 'lib',
          viewUrl: '/board/boardView',
        },
        () => {},
        true
      )}
    </div>
  );
}
